import React, {lazy} from "react";
import { Button } from "@ariakit/react";

const Input = lazy(() => import("../Input"));
import {Select, SelectCheckbox} from "../Select";

class Filter extends React.Component {
    constructor(props) {
        super(props);

        console.log(props);
        this.filterElement = React.createRef();
        this.filterWrapper = React.createRef();
        let prefilter = [];
        this.handleSelectChange = this.handleSelectChange.bind(this);
        if (this.props.preFilter[this.props.filter.name] !== undefined) {
            for (let i = 0; i < this.props.preFilter[this.props.filter.name].length; i++) {
                prefilter.push({
                    label: this.props.preFilter[this.props.filter.name][i],
                    value: this.props.preFilter[this.props.filter.name][i],
                    isprefilter: true,
                });
            }
        }
        this.state = {
            prefilter,
            hasFocus: false,
            currentValue: "",
            hiddenSelectedValuesAreExpanded: false,
            maxValue: window["myTalentionConfig"]?.filterValuesMaximumToShow || 3,
            items: [...prefilter]
        };

    }


    handleFilterReset = () => {
        if (this.props.config.keepJobPrefilter) {
            this.setState({
                items: [...this.state.prefilter]
            });
        } else {
            this.setState({
                items: []
            });
        }


    };
    handleSelectChange = (value) => {
        if (value !== undefined) {
            this.props.handleFilterChange(this.props.filter.name, value);
        }
    };

    handleFocusClass = () => {
        this.setState({
            hasFocus: true
        });
        this.filterWrapper.current.classList.add("tms-is-in-focus");
    };
    handleFocusInput = () => {
        this.filterElement.current.focus();
        this.props.showFancyOverlay(true);

    };
    resetValues = () => {
        this.handleFilterReset();
    };
    onlyUnique = (value, index, array) => {
        return array.indexOf(value) === index;
    };
    handleRemove = (valueToRemove) => {

        let newList = this.state.items;
        const index = newList.map(e => e.value)
            .indexOf(valueToRemove);

        const removed = newList.splice(index, 1);
        let output = newList;
        if (this.props.config.keepJobPrefilter) {
            newList = [...this.state.prefilter, ...newList];
            output = [...newList.filter(this.onlyUnique)];
        }
        this.setState({
            items: output
        });
        const indexPrefilter = this.state.prefilter.map((e) => {
            return e.value;
        }).indexOf(valueToRemove);

        if (indexPrefilter === -1) {
            this.props.handleFilterRemove(this.props.filter.name, valueToRemove);
        }

    };

    addToItems = (item) => {
        this.setState({
            items: [...this.state.items, item]
        }, () => {
            this.filterElement.current.value = "";
            this.filterElement.current.style = "width:2px;box-sizing:content-box; display:inline";
        });
    };
    toggleAllSelectedValues = () => {
        // console.log("toggleAllSelectedValues");

        this.setState({
            hiddenSelectedValuesAreExpanded: !this.state.hiddenSelectedValuesAreExpanded
        });

    };
    handleHiddenSelectedValues = () => {

        if (this.state.hiddenSelectedValuesAreExpanded) {
            return <span onClick={() => this.toggleAllSelectedValues()}
                className={["tms-filter-value-tag", "tms-filter-value-tag-less"].join(" ")}>weniger anzeigen</span>;
        }
        if ((this.state.items.length) - this.state.maxValue >= 1) {

            return <span onClick={() => this.toggleAllSelectedValues()}
                className={["tms-filter-value-tag", "tms-filter-value-tag-more"].join(" ")}>+{(this.state.items.length) - this.state.maxValue} weitere</span>;

        }

        return null;
    };

    isInFocus = () => {
        // this.filterElement.current.input.classList.remove("tms-is-in-focus");
        // console.log(131213);
    };
    handleChange = (event) => {
        const inputValue = this.filterElement.current.input.value;

        this.setState({
            currentValue: inputValue
        });
    };
    handleExternalChange = (value) => {
        this.filterElement.current.setSelectedValues(value);
    };
    handleBlur = (e) => {

        this.filterWrapper.current.classList.remove("tms-is-in-focus");
        console.log("blurring",e);
        this.setState({
            hasFocus: false
        });
        this.props.showFancyOverlay(false);
    };
    handleKeyDown = (event) => {

        /**
         * If no text is in the input we have removed the values.
         * If backspace is pressed and the input is empty remove the last element in the list of filtered values
         */
        const inputValue = this.filterElement.current.input.value;
        if (this.state.items.length && inputValue === "" && event.key === "Backspace") {

            const newList = [...this.state.items];

            /**
             * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/pop
             */
            let removedValue = null;
            if (newList.length > this.state.maxValue) {
                removedValue = newList.splice(this.state.maxValue - 1, 1);
                //console.log("4");
            } else {
                // console.log("n");
                removedValue = newList.pop();
            }
            // console.log(removedValue);
            const index = this.state.prefilter.map((prevalue) => {
                return prevalue.value;
            }).indexOf(removedValue.value);

            if (index === -1) {
                this.props.handleFilterRemove(this.props.filter.name, removedValue.value);
                this.setState({
                    items: newList
                });
            }
        }
        if (event.key === "Enter" && event.target.value.trim().length) {
            const value = event.target.value;
            event.preventDefault();

            /**
             * we check if the new filter value is already present, if not do stuff.
             * Not present if -1
             */
            const index = this.state.items.findIndex(item => item.value === value);

            const values = [...this.state.items];
            values.unshift({
                label: value,
                value
            });

            if (index === -1) {
                this.setState({
                    items: values,
                    currentValue: ""
                }, () => {
                    this.props.handleFilterChange(this.props.filter.name, this.state.items);
                });

            }
        }

    };

    sortByIsprefilter = (arr) => {
        return arr.sort((a, b) => {
            // Prüfe, ob die Eigenschaft "isprefilter" existiert und welchen Wert sie hat
            const aHasPrefilter = a.hasOwnProperty("isprefilter") && a.isprefilter;
            const bHasPrefilter = b.hasOwnProperty("isprefilter") && b.isprefilter;

            // Falls a nicht "isprefilter" hat und b hat es, dann a vor b
            if (!aHasPrefilter && bHasPrefilter) {
                return 1;
            }

            // Falls a "isprefilter" hat und b nicht, dann b vor a
            if (aHasPrefilter && !bHasPrefilter) {
                return -1;
            }

            // Ansonsten bleibt die Reihenfolge gleich
            return 0;
        });
    };
    render() {

        const {
            filter,
        } = this.props;
        const {items} = this.state;
        if (filter.type === "input") {
            return (
                <div
                    ref={this.filterWrapper}
                    aria-live="assertive"
                    onClick={() => {
                        this.handleFocusInput();
                        this.handleFocusClass();
                    }}
                    onBlur={this.handleBlur}
                    className={[
                        "tms-filter-item",
                        `tms-filter-item--${filter.type}`,
                        `tms-filter-item--${filter.name}`,
                        items.length ? "tms-filter-item--has-items" : null

                    ].join(" ")}
                >
                    <div className={"tms-filter-item-input-inner"}>
                        <div className={"tms-label"} aria-hidden="true">
                            <span>{filter.label || filter.placeholder}</span></div>

                        <div className={"tms-filter-value-tag-wrapper"}>
                            {filter.placeholder && (items.length === 0 && this.state.currentValue.length === 0) && !this.state.hasFocus ?
                                <div className={"tms-placeholder"}>
                                    {filter.placeholder}
                                </div> : null}
                            {this.sortByIsprefilter(items).map((item, key) => {
                                if (!this.state.hiddenSelectedValuesAreExpanded && key >= this.state.maxValue) {
                                    return null;
                                }
                                return (
                                    <div key={key} onClick={() => {
                                        this.handleRemove(item.value);
                                    }}
                                    className={`tms-filter-value-tag ${item.isprefilter ? "tms-is-prefilter" : ""}`}><Button type={"button"}>{item.value}</Button><span><svg
                                            className={"tms-select-replacement-item-icon"}
                                            height="14" width="14"
                                            viewBox="0 0 20 20" aria-hidden="true"
                                            focusable="false"
                                        ><path
                                                d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"/></svg></span>
                                    </div>
                                );

                            })}
                            <Input
                                translations={this.props.translations}
                                showFancyOverlay={this.props.showFancyOverlay}
                                onChange={this.handleChange}
                                handleFocusClass={this.handleFocusClass}
                                onKeyDown={
                                    this.handleKeyDown
                                }
                                ref={this.filterElement}
                                isInFocus={this.state.hasFocus}
                                showLabel={true}
                                className={"tms-filter--filterable"}
                                value={this.state.currentValue}
                                name={filter.name}
                                aria-label={filter.placeholder}
                                placeholder={false}
                            />
                            {this.handleHiddenSelectedValues()}

                        </div>

                    </div>
                </div>
            );
        }

        if (filter.type === "select") {
            return (
                <div
                    aria-live="assertive"
                    ref={this.filterWrapper}
                    onClick={this.handleFocusClass}
                    onBlur={this.handleBlur}
                    className={[
                        "tms-filter-item",
                        `tms-filter-item--${filter.name}`,
                        `tms-filter-item--${filter.type}`,
                    ].join(" ")}
                >
                    <Select
                        change={(value) => {
                            this.handleSelectChange(value);
                        }}
                        handleBlur={this.handleBlur}
                        ref={this.filterElement}
                        showFancyOverlay={this.props.showFancyOverlay}
                        options={filter.options}
                        required={true}
                        isInFocus={this.state.hasFocus}
                        config={this.props.config}
                        showLabel={filter.showLabel}
                        maxValues={filter?.maxValues}
                        handleFocusClass={this.handleFocusClass}
                        multiple={filter.multiple ? filter.multiple : true}
                        preSelectedValues={this.props.preFilter[filter.name] ? this.props.preFilter[filter.name] : []}
                        className={"tms-filter--filterable"}
                        label={`${filter.label}`}
                        name={filter.name}
                    />
                </div>
            );
        }
        return false;

    }
}

export default React.memo(Filter);
